import React from 'react'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'

import type { IColumn } from 'types'

interface Props extends HTMLAttributes<HTMLTableRowElement> {
  columns: IColumn[]
  data: Record<string, React.ReactNode>
  position?: string
  verticalAlign?: string
  classNameTBody?: string
}

const Row: React.FC<Props> = ({
  columns,
  data,
  children,
  className,
  position,
  verticalAlign,
  ...rest
}: Props) => {
  const base = 'tbody'
  const cn = clsx(
    `${base}__row`,
    rest.onClick && `${base}__row--clickable`,
    className,
  )

  return (
    <>
      <tr {...rest} className={cn}>
        {columns.map((column) => (
          <td
            key={column.key}
            className={clsx(
              `${base}__cell--${column.className}`,
              `${base}__cell`,
              `table__cell--w${column.width}`,
              column.textAlign && `${base}__cell--${column.textAlign}`,
              position === 'left' && `${base}__cell--left`,
              verticalAlign === 'baseline' && `${base}__cell--baseline`,
            )}
          >
            {data[column.key]}
          </td>
        ))}
      </tr>
      {children}
    </>
  )
}

export default Row
